/* ============================================================
   assets/msk-price.js  —  Module de PRIX UNIVERSEL
   ------------------------------------------------------------
   Source de verite : window.Shopify.currency (active + rate).
   - Aucune logique par pays/devise codee en dur pour la conversion.
   - Pays / locale / devise = 3 infos distinctes. Jamais navigator.language.
   - Anti double-conversion : on ne convertit que depuis la devise de
     base (EUR), et une seule fois par element (marqueur dataset.mpDone) ;
     un prix deja localise par Shopify n'est jamais touche.
   - Seule exception devise, isolee : marge commerciale UK ->
     MskPrice.commercialAdjust (REGLE METIER, PAS appelee par le
     systeme generique ; seuls theme.js / au-patch.js l'appellent).
   - Ne touche pas au panier / checkout.

   v2 (2026-08-29) : FX de secours. Sur une page SANS prefixe de
   marche, Shopify peut rester en devise de base alors que le
   visiteur releve d'un marche a devise non-EUR (redirection non
   appliquee : lien interne code en dur sans prefixe, crawler,
   JS bloque...). Dans ce cas on recupere UNE fois le vrai
   contexte (devise + rate REELS Shopify) depuis l'URL du marche
   et on l'utilise pour le balayage. Cache en sessionStorage.
   ============================================================ */
window.MskPrice = (function () {
  'use strict';

  var BASE = 'EUR';
  var UK_MARGIN = 1.1111;     // marge commerciale GBP — REGLE METIER (source unique)
  var DONE = 'mpDone';
  var FX_KEY = 'msk_fx_v1';

  // pays -> subfolder du marche a devise non-EUR (routage FX de secours uniquement)
  var MKT_SUB = {
    GB: 'gb', US: 'us', CA: 'us', CH: 'ch', SA: 'sa', AU: 'au', NZ: 'au',
    DK: 'eu', SE: 'eu', PL: 'eu', CZ: 'eu', HU: 'eu', RO: 'eu'
  };
  var _fx = null;   // { active, rate } resolu de secours (devise != BASE)

  /* ---- 1. Detection devise / taux ---- */
  function shopifyActive() {
    try { var s = window.Shopify; if (s && s.currency && s.currency.active) return s.currency.active; } catch (e) {}
    try { if (window.__st && window.__st.p && window.__st.p.c) return window.__st.p.c; } catch (e) {}
    return BASE;
  }
  function activeCurrency() {
    var a = shopifyActive();
    if (a && a !== BASE) return a;      // Shopify a resolu un marche -> il fait foi
    if (_fx && _fx.active) return _fx.active;   // sinon FX de secours si dispo
    return a || BASE;
  }
  function activeRate() {
    try { var r = parseFloat(window.Shopify.currency.rate); if (r > 0 && r !== 1) return r; } catch (e) {}
    if (_fx && _fx.rate > 0) return _fx.rate;
    return 1;
  }

  /* ---- 2. Conversion UNIQUE, anti double-conversion ---- */
  function getPriceInActiveCurrency(amountSource, sourceCurrency) {
    sourceCurrency = sourceCurrency || BASE;
    if (activeCurrency() === sourceCurrency) return amountSource;   // deja bonne devise -> pas de reconversion
    return amountSource * activeRate();                             // rate applique UNE seule fois
  }

  /* ---- 3. Marge commerciale UK — EXCEPTION isolee (source unique du 1.1111) ---- */
  function commercialAdjust(amount, currency) {
    return currency === 'GBP' ? amount * UK_MARGIN : amount;
  }

  /* ---- 4. Formatage : natif pour la devise de base, sinon Intl (pas de table de symboles) ---- */
  var _nf = {};
  function formatPrice(amount, currency) {
    currency = currency || activeCurrency();
    var n = Math.round(amount);
    if (currency === BASE) return '€' + n;      // honore shop.money_format "€{{amount}}"
    try {
      var loc = (window.Shopify && window.Shopify.locale) || 'en';
      var k = loc + '|' + currency;
      var f = _nf[k] || (_nf[k] = new Intl.NumberFormat(loc, {
        style: 'currency', currency: currency,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }));
      return f.format(n);
    } catch (e) {
      return n + ' ' + currency;
    }
  }

  /* ---- 5. Rendu haut niveau : prix source EUR -> chaine (systeme generique, SANS marge) ---- */
  function display(amountSourceEur) {
    return formatPrice(getPriceInActiveCurrency(amountSourceEur, BASE), activeCurrency());
  }

  /* ---- 6. Balayage DOM generique ---- */
  var SELECTOR = ['.prod-price', '.prod-compare-price',
                  '.product-price', '.product-compare-price',
                  '.sticky-atc-price', '.quick-shop-price', '#qs-price'].join(',');

  // n'accepte QUE des montants dans la devise de base (prefixe €) -> jamais de reconversion
  function parseBaseText(txt) {
    var m = String(txt).trim().match(/^€\s*([\d.\s ]*\d)(?:[.,](\d{1,2}))?$/);
    if (!m) return null;
    var intp = m[1].replace(/[.\s ]/g, '');
    var dec = m[2] ? parseInt(m[2], 10) / Math.pow(10, m[2].length) : 0;
    var v = parseInt(intp, 10) + dec;
    return (isNaN(v) || v <= 0) ? null : v;
  }

  function convertEl(el) {
    if (!el || !el.dataset || el.dataset[DONE]) return;
    if (activeCurrency() === BASE) return;               // aucune devise cible -> rien a faire
    var txt = (el.textContent || '').trim();
    if (!txt) return;
    // On NE convertit QUE si le texte est un montant en devise de base (€…) ou un nombre nu.
    // Un prix deja localise par Shopify ($108, £57, CHF 63, 290 SR…) est laisse intact.
    var eur = parseBaseText(txt);
    if (eur === null && /^\d{1,7}([.,]\d{1,2})?$/.test(txt)) eur = parseFloat(txt.replace(',', '.'));
    if (eur === null || eur <= 0) return;
    el.textContent = display(eur);
    el.dataset[DONE] = '1';
  }

  function sweep(root) {
    try { (root || document).querySelectorAll(SELECTOR).forEach(convertEl); } catch (e) {}
  }

  /* ---- 7. FX de secours : recupere devise + rate REELS depuis l'URL du marche ---- */
  function targetSub() {
    var cc = '';
    try { cc = (window.MSK_GEO_CC || window.MSK_COUNTRY || '').toUpperCase(); } catch (e) {}
    return MKT_SUB[cc] || null;
  }
  function resolveFx(cb) {
    // deja resolu (memoire ou session) ?
    if (_fx) return cb();
    try { var s = sessionStorage.getItem(FX_KEY); if (s) { _fx = JSON.parse(s); return cb(); } } catch (e) {}
    // Shopify a deja une devise non-EUR -> pas besoin de secours
    if (shopifyActive() !== BASE) return cb();
    var sub = targetSub();
    if (!sub) return cb();                               // pays EUR / inconnu -> rien a faire
    var lang = 'fr';
    try { lang = (window.MSK_LANGUAGE || 'fr').toLowerCase(); } catch (e) {}
    if (!/^(fr|en|de|es|it|nl|pt)$/.test(lang)) lang = 'fr';
    var done = false;
    var finish = function () { if (!done) { done = true; cb(); } };
    try {
      fetch('/' + lang + '-' + sub + '/', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/Shopify\.currency\s*=\s*\{[^}]*"active"\s*:\s*"([A-Z]{3})"[^}]*"rate"\s*:\s*"([\d.]+)"/);
          if (m && m[1] !== BASE && parseFloat(m[2]) > 0) {
            _fx = { active: m[1], rate: parseFloat(m[2]) };
            try { sessionStorage.setItem(FX_KEY, JSON.stringify(_fx)); } catch (e) {}
          }
        })
        .catch(function () {})
        .then(finish, finish);
      setTimeout(finish, 4000);   // ne jamais bloquer l'affichage
    } catch (e) { finish(); }
  }

  /* ---- 8. Demarrage : (FX secours) -> 1 sweep + 1 observer partage ---- */
  var _pending = false;
  function schedule() {
    if (_pending) return;
    _pending = true;
    (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () { _pending = false; sweep(); });
  }
  function start() {
    resolveFx(function () {
      sweep();
      try {
        new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  return {
    activeCurrency: activeCurrency,
    activeRate: activeRate,
    getPriceInActiveCurrency: getPriceInActiveCurrency,
    commercialAdjust: commercialAdjust,
    formatPrice: formatPrice,
    display: display,
    convertEl: convertEl,
    sweep: sweep
  };
})();
